var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.307,
    height: 13.307,
    viewBox: "0 0 13.307 13.307",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logout",
    transform: "translate(-1990.876 -784.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M1992.589,794.44h5.967a.6.6,0,1,0,0-1.191h-5.967l.678-.678a.6.6,0,1,0-.843-.843l-1.15,1.15h0a1.369,1.369,0,0,0,0,1.932l1.149,1.149a.6.6,0,0,0,.843-.843Z",
    transform: "translate(0 -2.291)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M2004.069,784.875h-5.16a2.141,2.141,0,0,0-2.136,2.136v1.026a.6.6,0,1,0,1.191,0v-1.026a.947.947,0,0,1,.945-.945h5.161a.947.947,0,0,1,.944.944v9.037a.947.947,0,0,1-.944.944h-5.161a.948.948,0,0,1-.944-.944V795.02a.6.6,0,0,0-1.185-.082l-.006,1.109a2.141,2.141,0,0,0,2.136,2.135h5.161a2.141,2.141,0,0,0,2.135-2.135v-9.036A2.142,2.142,0,0,0,2004.069,784.875Z",
    transform: "translate(-2.022 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.dab0dfd3787920d2c6bccd85e71ed289.svg";
export { ForwardRef as ReactComponent };